import { Injectable } from '@angular/core';
import { AttachmentDTO, AttachmentType } from './api/api';
import { BehaviorSubject } from 'rxjs';
import { AttachmentEditEmitter } from './global/global-interfaces';

@Injectable()
export class AttachmentService {
  url: string;
  attachmentChange: BehaviorSubject<AttachmentEditEmitter>;
  linkUploadMode: BehaviorSubject<boolean>;

  constructor() {}

  createSubjects(): Promise<void> {
    return new Promise(res => {
      this.attachmentChange = new BehaviorSubject<AttachmentEditEmitter>(null);
      this.linkUploadMode = new BehaviorSubject<boolean>(null);
      res();
    });
  }

  updateIframeUrl(attachment: AttachmentDTO): string | undefined {
    if (attachment.attachmentType === AttachmentType.UPLOAD) {
      this.url = attachment.fileLink.toString();
    }
    if (attachment.attachmentType === AttachmentType.LINK) {
      this.url = attachment.link;
    }
    return this.url;
  }
}
